export default {
  methods: {
    translate (...args) {
      return this.$options.filters.translate(...args)
    },
    translateLoc (locale, ...args) {
      return this.$options.filters.translateLoc(locale, ...args)
    }
  }
}
